var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from './dialog.style';
import { classNames } from '../../utils/style-class.utils';
export var Dialog = function (_a) {
    var visible = _a.visible, children = _a.children, position = _a.position, _b = _a.stretch, stretch = _b === void 0 ? false : _b, _c = _a.solidBackdrop, solidBackdrop = _c === void 0 ? false : _c, _d = _a.backdropColour, backdropColour = _d === void 0 ? 'modalBg' : _d, _e = _a.borderRadius, borderRadius = _e === void 0 ? 'rounded' : _e, _f = _a.fullScreen, fullScreen = _f === void 0 ? false : _f, _g = _a.className, className = _g === void 0 ? '' : _g;
    return (_jsx(_Fragment, { children: visible && (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: classNames(styles.getWrapperStyle(position), className), "data-testid": "dialog-wrapper" }, { children: _jsx("div", __assign({ className: styles.getContentWrapperStyles(stretch, borderRadius, fullScreen) }, { children: children })) })), _jsx("div", { className: classNames(solidBackdrop ? styles.bottomDivSolid : styles.bottomDiv, "bg-".concat(backdropColour)) })] })) }));
};
//# sourceMappingURL=dialog.js.map